/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Position_Bottom_Right_LabelInputs */

const en_style_guide_manager_position_bottom_right_label = /** @type {(inputs: Style_Guide_Manager_Position_Bottom_Right_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bottom Right`)
};

const fr_style_guide_manager_position_bottom_right_label = /** @type {(inputs: Style_Guide_Manager_Position_Bottom_Right_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bas droit`)
};

const de_style_guide_manager_position_bottom_right_label = /** @type {(inputs: Style_Guide_Manager_Position_Bottom_Right_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unten rechts`)
};

const it_style_guide_manager_position_bottom_right_label = /** @type {(inputs: Style_Guide_Manager_Position_Bottom_Right_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In basso a destra`)
};

const ru_style_guide_manager_position_bottom_right_label = /** @type {(inputs: Style_Guide_Manager_Position_Bottom_Right_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нижний правый угол`)
};

const es_style_guide_manager_position_bottom_right_label = /** @type {(inputs: Style_Guide_Manager_Position_Bottom_Right_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abajo a la derecha`)
};

const zh_cn2_style_guide_manager_position_bottom_right_label = /** @type {(inputs: Style_Guide_Manager_Position_Bottom_Right_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右下角`)
};

const ja_style_guide_manager_position_bottom_right_label = /** @type {(inputs: Style_Guide_Manager_Position_Bottom_Right_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右下`)
};

const hi_style_guide_manager_position_bottom_right_label = /** @type {(inputs: Style_Guide_Manager_Position_Bottom_Right_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नीचे दाएं`)
};

const pt_pt2_style_guide_manager_position_bottom_right_label = /** @type {(inputs: Style_Guide_Manager_Position_Bottom_Right_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canto inferior direito`)
};

/**
* | output |
* | --- |
* | "Bottom Right" |
*
* @param {Style_Guide_Manager_Position_Bottom_Right_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_position_bottom_right_label = /** @type {((inputs?: Style_Guide_Manager_Position_Bottom_Right_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Position_Bottom_Right_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_position_bottom_right_label(inputs)
	if (locale === "de") return de_style_guide_manager_position_bottom_right_label(inputs)
	if (locale === "it") return it_style_guide_manager_position_bottom_right_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_position_bottom_right_label(inputs)
	if (locale === "es") return es_style_guide_manager_position_bottom_right_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_position_bottom_right_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_position_bottom_right_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_position_bottom_right_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_position_bottom_right_label(inputs)
	return en_style_guide_manager_position_bottom_right_label(inputs)
});